import { ReportedBy } from 'api/timeline/types';

const USER_UNKNOWN_NAME = 'User unknown';

export const isUserUnknown = (user?: ReportedBy | null): boolean => {
  return formatUserDisplayName(user) === USER_UNKNOWN_NAME;
};

export const formatUserDisplayName = (user?: ReportedBy | null): string => {
  if (!user) {
    return USER_UNKNOWN_NAME;
  }

  // If userId exists, use firstName and lastName
  if (user.userId || user?.[0]) {
    const firstName = user?.firstName || user?.[0]?.firstName || '';
    const lastName = user?.lastName || user?.[0]?.lastName || '';

    if (!firstName && !lastName) {
      return USER_UNKNOWN_NAME;
    }

    return `${firstName} ${lastName}`.trim();
  }

  // If email exists, use that
  if (user.emailId || user?.[0]) {
    return user?.emailId || user?.[0]?.emailId || '';
  }

  // Default fallback
  return USER_UNKNOWN_NAME;
};

export const formatRoleDisplay = (user?: ReportedBy | null): string => {
  if (!user || (Array.isArray(user) && user.length === 0)) {
    return "Can't find the participant";
  }

  // Check if role exists and has a roleName
  if (user?.role?.roleName) {
    return user.role.roleName;
  }

  return '';
};
